<template>

  <div class="box-table">
    <div class="horizontal-responsive">
    <button type="button" class="button button-small dirty-margin float-right"
      @click="exportExcel">Exportar datos a Excel</button>
      <v-client-table class="table-virtualaccount" :columns="columns" :data="object" :options="options">
        <div slot="transaction_date" slot-scope="{row}">
          {{ format(row.transaction_date, 'DD/MM/YYYY') }}
        </div>
        <div slot="credit" slot-scope="{row}">
          {{ formatCurrency(row.credit) }}
        </div>
        <div slot="debit" slot-scope="{row}">
          {{ formatCurrency(row.debit) }}
        </div>
        <div slot="categoria" slot-scope={row}>
          <span class="pill" :class="typeCategory(row.credit, row.debit)">
          </span>
          {{ row.categoria }}
        </div>
        <div slot="funding_request_id" slot-scope="{row}">
          <a
            href="#"
            class="funding-link"
            v-if="row.funding_request_id"
            @click.prevent="goToFundingRequest(
                row.funding_request_id)">
            {{ row.funding_request_id }}
          </a>
        </div>
        <div slot="rate" slot-scope="{row}">
          <div v-if="row.rate !== null">
          {{ formatPercentage(row.rate) }}
          </div>
          <div class="-centered-info" v-else>
            -
          </div>
        </div>
      </v-client-table>
    </div>
  </div>

</template>

<script>

import Vue from 'vue'
import { format } from 'date-fns'
import XLSX from 'xlsx'
import { ClientTable } from 'vue-tables-2'

import mixins from '@/mixins/index'

Vue.use(ClientTable)

export default {
  name: 'DashboardVirtualAccountsTable',
  props: { object: Array },
  data () {
    return {
      format,
      allFilterValue: '',
      columns: [
        'transaction_date',
        'business_name',
        'credit',
        'debit',
        'categoria',
        'funding_request_id',
        'investment_id',
        'rate'],
      options: {
        headings: {
          transaction_date: 'Fecha',
          business_name: 'Empresa solicitante',
          credit: 'Depósitos',
          debit: 'Cargos',
          categoria: 'Categoría',
          funding_request_id: 'ID Crédito',
          investment_id: 'ID Inversión',
          rate: 'Tasa'
        },
        texts: {
          count: 'Filas {to} de {count}',
          filter: '',
          filterPlaceholder: 'Buscar',
          first: 'Inicio',
          last: 'Fin',
          limit: 'Registros por página',
          noResults: 'No se encontraron registros'
        },
        sorteable: true,
        filterable: true,
        initialPage: 1,
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        pagination: {
          dropdown: false,
          chunk: 6,
          edge: true,
          nav: 'fixed'
        },
        resizableColumns: false
      }
    }
  },
  mixins: [mixins],
  methods: {
    exportExcel: function () {
      let data = XLSX.utils.json_to_sheet(
        this.object,
        {
          header: [
            'transaction_date',
            'business_name',
            'credit', 'debit',
            'categoria',
            'funding_request_id',
            'investment_id',
            'rate'
          ]
        }
      )
      data['A1'].v = 'Fecha'
      data['B1'].v = 'Empresa solicitante'
      data['C1'].v = 'Depósitos'
      data['D1'].v = 'Cargos'
      data['E1'].v = 'Categoría'
      data['F1'].v = 'ID Crédito'
      data['G1'].v = 'ID Inversión'
      data['H1'].v = 'Tasa'

      const workbook = XLSX.utils.book_new()
      const filename = 'cumplo-cuentas-virtuales'

      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    typeCategory: function (creditAmount, debitAmount) {
      let type

      if (creditAmount === 0) {
        type = 'credit'
      } else if (debitAmount === 0) {
        type = 'debit'
      }
      return type
    }
  }
}

</script>

<style lang="scss">

.VueTables__search {
  margin-left: 2rem;
}

.VueTables__limit-field {
  margin-left: 2rem;
}

.VuePagination {
  text-align: center;

  > nav {
    width: 100%;

    > .VuePagination__pagination {
      display: block;

      > li {
        margin: 0 2px;

        a {
          padding: 4px 8px;
          background-color: $midnight-blue;
          color: $white;

          &.active {
            background-color: $yellow;
          }
        }

        &:before {
          display: none;
        }
      }
    }
  }

  li {
    display: inline-block;
  }
}

.table-virtualaccount {
  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
}

</style>

<style lang="scss" scoped>

.dirty-margin {
  margin-bottom: -4rem;

  @media (max-width: 42rem) {
    float: none;
    margin: 0 auto 1rem;
  }
}

.pill {
  $s: 18px;

  display: inline-block;
  width: $s;
  height: $s;
  margin-bottom: -4px;
  margin-right: 5px;
  background-color: #ccc;
  border-radius: 50%;

  &.debit {
    background: url(/static/svg/icon_entypo-download.svg);
  }
  &.credit {
    background: url(/static/svg/icon_entypo-upload.svg);
  }
}

@media (max-width: 42rem) {
  .button-block {
    display: block;
  }

  .button-cta-invest {
    float: none;
  }
}

.button-icon {
  margin-bottom: -6px;
}

.balanceavailable {
  line-height: 2;
  font-size: 1.2em;
}

.funding-link {
  padding-left: 20px;
  font-weight: bold;
  background: url(/static/svg/icon_clarity-link.svg) center left no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboardVirtualAccount/DashboardVirtualAccountsTable.vue